<script lang="ts">
    let { data }: { data: any } = $props();
    function convertPatronsToTiers(patronList: any[]) {
        let tiers: Record<string, any[]> = {};
        patronList.forEach((el) => {
            if (el.category in tiers == false) {
                tiers[el.category] = [];
            }
            tiers[el.category].push(el);
        });
        return Object.keys(tiers).map((key) => {
            return {
                name: key,
                patrons: tiers[key],
            };
        });
    }
    function toDollars(cents: number) {
        let amount = cents / 100;
        return amount.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        });
    }
    const patreonLink = $derived(data.metadata.patreon_link);
    const donations = $derived(
        data.supporters.filter((x: any) => x.type == "donation")
    );
    const subscribers = $derived(
        data.supporters.filter((x: any) => x.type == "subscriber")
    );
    const bits = $derived(
        data.supporters.filter((x: any) => x.type == "bits")
    );
    const patronList = $derived(
        data.supporters.filter((x: any) => x.type == "patreon")
    );
    const patrons = $derived(convertPatronsToTiers(patronList));
    const hasTwitch = $derived(
        subscribers.length > 0 || bits.length > 0 || donations.length > 0
    );
    const hasPatreon = $derived(patronList.length > 0);
    const fontFamily = $derived(
        `"${data.metadata.primary_font || "Aniron"}", Arial, Helvetica, sans-serif`
    );
</script>

<div class="scroll-container" style:font-family={fontFamily}>
    {#if subscribers.length > 0}
        <h2>{data.metadata.label_subscriptions}</h2>
        <ul
            class:single={subscribers.length === 1}
            class:pair={subscribers.length === 2}
        >
            {#each subscribers as entry}
                <li>{entry.name}</li>
            {/each}
        </ul>
    {/if}
    {#if Object.keys(bits).length > 0}
        <h2>{data.metadata.label_bits}</h2>
        <ul class:single={bits.length === 1} class:pair={bits.length === 2}>
            {#each bits as entry}
                <li>{entry.name} ({entry.amount})</li>
            {/each}
        </ul>
    {/if}
    {#if Object.keys(donations).length > 0}
        <h2>{data.metadata.label_donations}</h2>
        <ul
            class:single={donations.length === 1}
            class:pair={donations.length === 2}
        >
            {#each donations as entry}
                <li>{entry.name} ({toDollars(entry.amount)})</li>
            {/each}
        </ul>
    {/if}
    {#if hasPatreon}
        {#if hasTwitch}
            <p>And special thanks to all my patrons...</p>
        {/if}
        {#each patrons as tier}
            <h2>{tier.name}</h2>
            <ul
                class:single={tier.patrons.length === 1}
                class:pair={tier.patrons.length === 2}
            >
                {#each tier.patrons as entry}
                    <li>{entry.name}</li>
                {/each}
            </ul>
        {/each}
        <p>
            To become a patron of mine, visit <a href={patreonLink}
                >{patreonLink}</a
            >
        </p>
        <p>{data.metadata.footer_message}</p>
    {/if}
</div>

<style type="text/css">
    a {
        color: white;
        text-decoration: underline;
    }
    h2 {
        font-size: 1.25em;
        text-decoration: underline;
    }
    li {
        break-inside: avoid;
        padding-bottom: 1em;
    }
    p:last-child {
        padding-bottom: 6em;
    }
    .scroll-container {
        animation: scroll-up 45s linear infinite;
        color: white;
        /* font-family is set dynamically from the user's primary_font */
        font-size: 2em;
        min-height: 100%;
        text-align: center;
        text-shadow: 3px 3px black;
        transform: translateY(-100%);
    }
    ul {
        column-count: 3;
        list-style-type: none;
        margin: 0;
        padding: 0 0 4em;
    }
    /* center a section's lone entry rather than leaving it in the left column */
    ul.single {
        column-count: 1;
    }
    /* balance a section with exactly two entries across two columns,
       with side padding so the pair isn't pushed to the edges */
    ul.pair {
        column-count: 2;
        padding: 0 20% 4em;
    }
    @keyframes scroll-up {
        from {
            transform: translateY(25%);
        }
        to {
            transform: translateY(-100%);
        }
    }
</style>
